
import { supabase } from "@/integrations/supabase/client";

export const makeAIApiCall = async (endpoint: string, messages: any[], model: string, aiEngine: string) => {
  const { data, error } = await supabase.functions.invoke('ai-chat-completion', {
    body: { messages, model: model || 'gpt-4o-mini' }
  });

  if (error) {
    console.error('Error calling ai-chat-completion:', error);
    // Return a Response-like object with ok=false for compatibility
    return {
      ok: false,
      status: 500,
      json: async () => ({ error: error.message }),
      text: async () => error.message
    };
  }

  // Return a Response-like object with ok=true for compatibility
  return {
    ok: true,
    status: 200,
    json: async () => data,
    text: async () => JSON.stringify(data)
  };
};
